// src/pages/earningsImport/earningsParser.js
import * as XLSX from "xlsx";

/**
 * Normalize column keys safely
 */
export function normalizeKey(key) {
  if (!key) return "";
  return String(key)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_");
}

/**
 * Read CSV/XLSX into JSON rows
 */
export async function parseFileToRows(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
        resolve(rows);
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = () => reject(reader.error);
    reader.readAsBinaryString(file);
  });
}

/**
 * Platform-Aware Parsing
 * Detect and normalize: driver_id, driver_name, bank_income, cash_income
 */
export function normalizeRows(rows) {
  return rows.map((row) => {
    const cleaned = {};

    // Normalize keys → cleaned[key]
    Object.keys(row).forEach((key) => {
      cleaned[normalizeKey(key)] = row[key];
    });

    /**
     * DRIVER ID DETECTION (platform smart)
     * Supports Uber / Bolt / Yango / Zed / Careem
     */
    const driver_id =
      cleaned["driver_uuid"] ||
      cleaned["driver_identifier"] ||
      cleaned["driver_id"] ||
      cleaned["uuid"] ||
      cleaned["partner_id"] ||
      cleaned["captain_id"] ||
      cleaned["individual_identifier"] ||
      cleaned["id"] ||
      "";

    /**
     * DRIVER NAME DETECTION
     */
    let name =
      cleaned["driver_name"] ||
      cleaned["driver"] ||
      cleaned["name"] ||
      cleaned["full_name"] ||
      cleaned["captain"] ||
      cleaned["captain_name"] ||
      "";

    // Handle Uber: first + last name
    if (!name && cleaned["driver_first_name"]) {
      name = `${cleaned["driver_first_name"] || ""} ${
        cleaned["driver_last_name"] || ""
      }`.trim();
    }

    // Clean name from bad characters
    name = String(name).replace(/\s+/g, " ").trim();

    /**
     * BANK INCOME
     */
    const bank_income =
      Number(cleaned["bank_income"]) ||
      Number(cleaned["net_earnings"]) ||
      Number(cleaned["total_paid_to_bank"]) ||
      Number(cleaned["earning_bank"]) ||
      0;

    /**
     * CASH INCOME
     */
    const cash_income =
      Number(cleaned["cash_income"]) ||
      Number(cleaned["total_cash_collected"]) ||
      Number(cleaned["cash_collected"]) ||
      0;

    return {
      raw: row,
      driver_id,
      name,
      bank_income,
      cash_income,
    };
  });
}
